import { fetchAPI } from "@/utils/fetchAPI";
import { fetchAPIAuth } from "@/utils/fetchAPIAuth";

type FetchForgotPassword = {
  email: string;
};

type FetchUpdatePassword = {
  email: string;
  newPassword: string;
  oldPassword: string;
};

type FetchResetPassword = {
  email: string;
  code: string;
  password: string;
};

export async function fetchForgotPassword({ email }: FetchForgotPassword) {
  const res = await fetchAPIAuth({
    url: `/auth/forgotPassword`,
    options: {
      method: "POST",
      body: JSON.stringify({ email }),
    },
  });
  return res;
}

export async function fetchUpdatePassword({ email, newPassword, oldPassword }: FetchUpdatePassword) {
  try {
    const res = await fetchAPI({
      url: `/account/update-password`,
      options: {
        method: "POST",
        body: JSON.stringify({ email, newPassword, oldPassword }),
      },
    });
    console.log(" res:", res);
    return res;
  } catch (error) {
    throw new Error();
  }
}

export async function fetchResetPassword({ email, code, password }: FetchResetPassword) {
  const res = await fetchAPIAuth({
    url: `/auth/changePassword`,
    options: {
      method: "POST",
      body: JSON.stringify({ email, code, password }),
    },
  });
  return res;
}

type FetchRefreshAccessToken = {
  refreshToken: string;
};


export async function fetchRefreshAccessToken({ refreshToken }: FetchRefreshAccessToken) {
  try {
    return fetchAPIAuth({
      url: `/auth/refreshToken`,
      options: {
        method: "POST",
        body: JSON.stringify({ refreshToken }),
      },
    });
  } catch (error) {
    throw new Error();
  }
}
